<template>
  <div class="content">
    <div class="md-layout">
     
       <div
        class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25  homestats-mobile"
      >
          <p>
             <md-icon style="color:green;">library_books</md-icon> {{stats.active}}
             <md-icon style="color:red">info_outline</md-icon> {{overduecount}}
           <md-icon style="color:orange">drafts</md-icon> {{stats.draft}}
           <md-icon style="color:blue">done</md-icon> {{stats.answered}}
          </p>
          
           
             
         
      </div>

      <div
        class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25  homestats"
      >
        <stats-card data-background-color="green">
          <template slot="header">
            <md-icon>library_books</md-icon>
          </template>

          <template slot="content">
            <p class="category">Memries</p>
            <h3 class="title">{{stats.active}}</h3>
          </template>

          <template slot="footer">
            <div class="stats">
              <!--<md-icon>date_range</md-icon>-->
              And still growing...
            </div>
          </template>
        </stats-card>
      </div>
       <div
        class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25 homestats"
      >
        <stats-card :data-background-color="overduecount > 0 ? 'red' : ''">
          <template slot="header">
            <md-icon>info_outline</md-icon>
          </template>

          <template slot="content">
            <p class="category">Total Overdue</p>
            <h3 class="title">{{overduecount}}</h3>
          </template>

          <template slot="footer">
            <div class="stats" v-if="overduecount > 0">
             <md-icon class="text-danger">warning</md-icon>
              Don't leave these hanging!
            </div>
            <div class="stats" v-if="overduecount == 0">
             Amazing...there is nothing overdue!
            </div>
          </template>
        </stats-card>
      </div>
      <div
        class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25  homestats"
      >
        <stats-card data-background-color="orange">
          <template slot="header">
            <md-icon>drafts</md-icon>
          </template>

          <template slot="content">
            <p class="category">Total Drafts</p>
            <h3 class="title">
              {{stats.draft}}
            </h3>
          </template>

          <template slot="footer">
            <div class="stats" v-if="stats.draft > 0">
              <md-icon>local_offer</md-icon>
              <a href="#/drafts">Don't forget to complete and activate these</a>
            </div>
          </template>
        </stats-card>
      </div>
     
      <div
        class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25  homestats"
      >
        <stats-card data-background-color="blue">
          <template slot="header">
             <md-icon>done</md-icon>
          </template>

          <template slot="content">
            <p class="category">Answered</p>
            <h3 class="title">{{stats.answered}}</h3>
          </template>

          <template slot="footer">
            <div class="stats">
              <md-icon>update</md-icon>
              You have answered this many questions!
            </div>
          </template>
        </stats-card>
      </div>
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50 memrylist"
      >
        <md-card>
          <md-card-header data-background-color="green">
            <md-button class="md-primary" :disabled="checkedMemries.length == 0"  style="float:right" v-on:click="showBatchAction = !showBatchAction">
                <small>Bulk Score</small>                  
              </md-button>
            <h4 class="title">Today's Memries</h4>
            <p class="category">Ok let's get these done!
               
            </p>
          </md-card-header>
          <md-card-content>
            <div class="loader" v-if="memries == null">
               <ring-loader :loading="true" color="orange" ></ring-loader>
            </div>
             <div v-if="memries && memries.length == 0">
               <h5>Wait, there's nothing here! What are you waiting for create a Memry now!</h5>
                <md-button class="md-round md-info" @click="createMemry()">
                        <md-tooltip md-direction="top">This is exciting!</md-tooltip>
                       <md-icon class="md-icon-button md-raised">create</md-icon> CREATE MEMRY NOW 
                </md-button>
             </div>
             <md-table v-if="memries" v-model="memries" :table-header-color="tableHeaderColor" >
                <md-table-row  slot="md-table-row" slot-scope="{ item }" :class="{'scored': item.score,'md-selected':item.id == memry.id}" class="select-memries" @click="showMemry(item)">
                  <md-table-cell md-label="">
                        <md-button class="md-info md-round md-xsmall" v-for="tag in item.tagpaths" v-bind:key="tag">
                          {{tag}}
                        </md-button><br clear="right"/>
                        {{ item.question }} 

                  </md-table-cell>
                  <md-table-cell md-label="Cycle"> {{item.cyclelbl}} </md-table-cell>
                  <md-table-cell md-label="Due">{{ item.duedatelbl }} </md-table-cell>
                  <md-table-cell md-label="Last Reviewed">{{ item.lastreviewedlbl }}</md-table-cell>
                  <md-table-cell ><md-checkbox v-model="checkedMemries" :value="item.id" /></md-table-cell>
                 </md-table-row>
              </md-table>
         <div>
          <md-dialog :md-active.sync="showBatchAction" class="batch_action_modal">
            <md-dialog-title>Score Memries  <div class="loader" style="float:right" v-if="processing">
               <ring-loader :loading="true" color="orange" ></ring-loader>
            </div>
            </md-dialog-title>
             
           <b>{{checkedMemries.length}} selected for scoring.</b><br/>
           
           If you're sure you have completed all of the selected memries then go ahead and score them now!
           <br/>
           
          <div >
          <b>When did you complete the review?</b>
          <div class="md-layout-item md-small-size-100 md-size-100">
               
                <span class="pre-switch-lbl">Today</span>
               <md-switch v-model="reviewedOnDueBatch" aria-label="Reviewed on Due Date" @click="switchType()" class="md-primary">
                 on Due Date
                </md-switch>

               
          </div>
          </div>
           <div>
          <b>Adjust the review cycle based on my response?</b>
          <div class="md-layout-item md-small-size-100 md-size-100">
               
                <span class="pre-switch-lbl">No, just keep score</span>
               <md-switch v-model="adjustCycleBatch" aria-label="Adjust Cycle" @click="adjustCyle()" class="md-primary">
                Yes, adjust for score of OK or worse
                 
                </md-switch>

               
          </div>
          
          <div> 
            <b>How was your review?</b> Rate yourself <span v-if="adjustCycle">and we'll adjust how soon you see this again based on your response.</span><span v-else> and we'll keep track of how you are doing!</span>      
          </div>
         <md-button class="md-round md-success"  @click="scoreBatch(5)">
           <md-tooltip md-direction="top">Instant recall!</md-tooltip>
            <md-icon class="md-icon-button md-raised">thumb_up</md-icon> Great!
          </md-button>
        
         <md-button class="md-round md-success"  @click="scoreBatch(3)">
           <md-tooltip md-direction="top">Very familiar</md-tooltip>
            <md-icon class="md-icon-button md-raised">check</md-icon> Good 
          </md-button>

           <md-button class="md-round md-warning"  @click="scoreBatch(2)">
           <md-tooltip md-direction="top">Got it with some effort</md-tooltip>
            <md-icon class="md-icon-button md-raised">remove</md-icon> OK 
          </md-button>
        

          <md-button class="md-round md-danger" @click="scoreBatch(1)">
           <md-tooltip md-direction="top">Not great, not so familiar!</md-tooltip>
            <md-icon class="md-icon-button md-raised">cancel</md-icon> Bad
          </md-button>
         

          <md-button class="md-round md-danger" @click="scoreBatch(0)">
           <md-tooltip md-direction="top">Did I learn this before?? No recollection!</md-tooltip>
            <md-icon class="md-icon-button md-raised">thumb_down</md-icon> Awful!
          </md-button>
         </div>
         
            <md-dialog-actions>
              <md-button  @click="showBatchAction = false">Cancel</md-button>
            
            </md-dialog-actions>
          </md-dialog>
          
        </div>
          </md-card-content>
        </md-card>
      </div>
      <div ref="answermemry"
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50"
      >
       <md-card v-if="memry" >
          <md-card-header data-background-color="green">
            <h4 class="title">Memry</h4>
            <div class="stats">
             <i class="md-icon md-icon-font md-theme-default" style="margin-right:5px;margin-left:10px;">alarm</i>
              <strong>Due</strong> {{memry.duedatelbl}}  
              <i class="md-icon md-icon-font md-theme-default" style="margin-right:5px;margin-left:10px;">update</i>
              <strong>Last Reviewed</strong> {{memry.lastreviewedlbl}} 
              <i class="md-icon md-icon-font md-theme-default" style="margin-right:5px;margin-left:10px;">date_range</i>
              <strong>Created</strong> {{memry.datecreatedlbl}} 
              <i class="md-icon md-icon-font md-theme-default" style="margin-right:5px;margin-left:10px;">replay</i>
              <strong>Cycle</strong> {{memry.cyclelbl}} 
               <router-link :to="{ name: 'Update Memry', params: { id: memry.id } }">
                  <i class="md-icon md-icon-font md-theme-default" style="float:right;cursor:pointer;">edit</i>
              </router-link>
              
          </div>
           
           
          </md-card-header>
          <md-card-content>

               <md-button class="md-info md-round md-small" v-for="tag in memry.tagpaths" v-bind:key="tag">
                 {{tag}}
              </md-button>
               <h3>{{memry.question}}</h3>
               
               <div v-if="memry.type == 0">
                 Before you click Review spend a minute trying to recall this on your own.
               </div>
              
               <div v-if="memry.type == 0">
                 <md-button class="md-primary" @click="showHint = !showHint" v-show="memry.hint">
                  <small>Show Hint</small>                  
                </md-button>
                 <md-button class="md-primary" v-on:click="showAnswer = !showAnswer">
                  <small>Ready to Review</small>                  
                </md-button>
               </div>
                <h6 v-if="showHint && memry.hint"><b>HINT</b><br/> {{memry.hint}}</h6>
                        <notifications></notifications>
        
               
               <h5 v-if="showAnswer || memry.type == 1" v-html="memry.answer"></h5>
               
              <hr v-if="showAnswer || memry.type == 1"/>
        <div v-show="showAnswer || memry.type == 1">  
           <div class="loader" style="float:right;" v-if="processing">
               <ring-loader :loading="true" color="orange" ></ring-loader>
            </div>
          <div v-if="memry.overdue">
          <b>When did you complete the review?</b>
          <div class="md-layout-item md-small-size-100 md-size-100">
               
                <span class="pre-switch-lbl">Today</span>
               <md-switch v-model="reviewedOnDue" aria-label="Reviewed on Due Date" @click="switchType()" class="md-primary">
                 on Due Date ({{memry.duedatelbl}}) 
                 
                </md-switch>

               
          </div>
          </div>
           <div>
          <b>Adjust the review cycle based on my response?</b>
          <div class="md-layout-item md-small-size-100 md-size-100">
               
                <span class="pre-switch-lbl">No, just keep score</span>
               <md-switch v-model="adjustCycle" aria-label="Adjust Cycle" @click="adjustCyle()" class="md-primary">
                Yes, adjust for score of OK or worse
                 
                </md-switch>

               
          </div>
          </div>
         
          <div> 
            <b>How was your review?</b> Rate yourself <span v-if="adjustCycle">and we'll adjust how soon you see this again based on your response.</span><span v-else> and we'll keep track of how you are doing!</span>      
          </div>
         <md-button class="md-round" v-bind:class="{'md-success':!memry.score || memry.score == 5}" @click="scoreMemry(memry,5)">
           <md-tooltip md-direction="top">Instant recall!</md-tooltip>
            <md-icon class="md-icon-button md-raised">thumb_up</md-icon> Great!
          </md-button>
        
         <md-button class="md-round" v-bind:class="{'md-success':!memry.score ||memry.score == 3}" @click="scoreMemry(memry,3)">
           <md-tooltip md-direction="top">Very familiar</md-tooltip>
            <md-icon class="md-icon-button md-raised">check</md-icon> Good 
          </md-button>

           <md-button class="md-round"  v-bind:class="{'md-warning':!memry.score ||memry.score == 2}" @click="scoreMemry(memry,2)">
           <md-tooltip md-direction="top">Got it with some effort</md-tooltip>
            <md-icon class="md-icon-button md-raised">remove</md-icon> OK 
          </md-button>
        

          <md-button class="md-round" v-bind:class="{'md-danger': !memry.score ||memry.score == 1}" @click="scoreMemry(memry,1)">
           <md-tooltip md-direction="top">Not great, not so familiar!</md-tooltip>
            <md-icon class="md-icon-button md-raised">cancel</md-icon> Bad
          </md-button>
         

          <md-button class="md-round" v-bind:class="{'md-danger':!memry.score || memry.score == 0}" @click="scoreMemry(memry,0)">
           <md-tooltip md-direction="top">Did I learn this before?? No recollection!</md-tooltip>
            <md-icon class="md-icon-button md-raised">thumb_down</md-icon> Awful!
          </md-button>
          
         </div>

          </md-card-content>
        </md-card>
      </div>
    </div>
  </div>
</template>

<script>

import axios from "axios";
import ApiService from "@/services/api.service";
import UtilService from "@/services/util.service";
import lodash from "lodash";
import moment from "moment";

import { RingLoader } from '@saeris/vue-spinners'
    

import {
  StatsCard,
  ChartCard,
  NavTabsCard,
  NavTabsTable,
  OrderedTable
} from "@/components";

export default {
  components: {
    StatsCard,
    ChartCard,
    NavTabsCard,
    NavTabsTable,
    OrderedTable,
    RingLoader
  },
  props: {
    tableHeaderColor: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      memries: null,
      tags: [],
      memry: {},
      overduecount: 0,
      todaycount: 0,
      errorString: null,
      showAnswer: false,
      showHint: false,
      reviewedOnDue: false,
      adjustCycle: false,
      reviewedOnDueBatch: false,
      adjustCycleBatch: false,
      stats: {},
      checkedMemries: [] ,
      showBatchAction: false,
      processing: false
    };
  },
  mounted() {
     
      this.getStats();

      ApiService.getTags()
        .then(response => { 
           
           
            if(!response || response.data == null) {
              this.tags = [];
            } else {
              this.tags = response.data;
               console.log("Fetching Tags", response.data);
            }

            this.getTodaysMemries(false,true);

        });
  },
  methods: {
    showMemry(memry) {
      this.memry = memry;
      this.showAnswer = false;
      this.showHint = false;
      this.reviewedOnDue = false;
      this.adjustCycle = false;
      
       this.scrollToQuestion();
     
    },

    getStats() {
       ApiService.getMemryStats().then(response=> {
          this.stats = response.data;
          console.log(response.data);
       })
    },
    
    scrollToQuestion() {
       var element = this.$refs["answermemry"];
        var top = element.offsetTop;

        window.scrollTo(0, top);
    },

    editMemry(memry) {
      console.log('Load edit');
     
    },
    createMemry() {
      this.$router.push({path: "newmemry"});
    },
    Reviewed(onDue) {

    },
  getTodaysMemries(refresh,checkdata) {
      
      if(!refresh)
        this.delayOver = false;

      ApiService.getTodaysMemries().then(resp => {
         
         
          if(!resp || resp == null || resp.data == null ) {
           
            return;
          }
          


          this.overduecount = 0;
          this.todaycount = 0;
          var listmemries = resp.data;
          this.memries = [];
          
          var memryResponse = UtilService.extendMemries(listmemries,this.tags);
          this.overduecount = memryResponse.overduecount;
          this.todaycount  = memryResponse.todaycount;
          this.memries = memryResponse.memries;


          this.memry = this.memries[0];
          

          //console.log('Current memries',this.memries);
       }, err => {
        console.error('ERROR ', err);
        this.errorString = err;
      });

  },
  scoreBatch(score) {

      this.processing = true;
      var batch = {memries: this.checkedMemries, score: score, useduedate: this.reviewedOnDueBatch, adjustCycle: this.adjustCycleBatch};
      
       if(this.checkedMemries == null || this.checkedMemries.length == 0) {
          this.notifyVue('Please select some memries!',false);
          return;
       }
       console.log('Scoring Batch',batch);
        let that = this;
        ApiService.updateBatchScore(batch).then((resp) => {
            if(resp != null && resp.data != null) {
               
              this.showBatchAction = false;

              this.getStats();
              this.getTodaysMemries(false,true);
 
              if(resp.data == false) {
                 this.notifyVue("Something went wrong scoring the memries",false);
              } else
                this.notifyVue('Memries have been scored!',true);

                 this.processing = false;
          }
          
        }, (err) => {
            this.notifyVue(err,false);
        });
  },

  scoreMemry(memry,score) {
      
    this.processing = true;

    memry.score = score;
    memry.useduedate = this.reviewedOnDue;
    memry.adjustCycle = this.adjustCycle;

    //console.log('Scoring memory',score, memry);
    let that = this;
    ApiService.updateMemryScore(memry).then((resp) => {
        if(resp != null && resp.data != null) {
          var mem = resp.data;
          var msg = '';
          if(mem.cycle <= memry.cycle && memry.cycle != 6) {
              //cycle was adjusted
              //maybe show a message here
          }

          if(memry.score >= 4) {
            msg = 'Great Job!';
          }
          
          //save in case will be updated
          if(memry.statsid === undefined) {
            //update home stats
            if(memry.overdue) {
              if(that.overduecount)
                that.overduecount--;
              if(that.stats && that.stats.answered)
                that.stats.answered++;
            }
          }

           this.processing = false;
          memry.statsid = mem.statsid;
          memry.score = memry.score;
          //memry.statsid = mem.statsid;
          //console.log(memry);
          msg += 'This will be asked again in ' + mem.nextlbl;
           this.notifyVue(msg,true);

           this.$forceUpdate();  
       }
       
    }, (err) => {
        this.notifyVue(err,false);
    });

    this.scrollToQuestion();
  
    },
    
    notifyVue(msg, success) {
      var color = success ? 'info' : 'warning';
      this.$notify({
        message: msg,
        icon: "add_alert",
        horizontalAlign: 'center',
        verticalAlign: 'top',
        type: color
      });
    }
  }
};
</script>
